<template>
  <IQOS>
      <MarketplaceSystems/>
  </IQOS>
</template>




<script>
import MarketplaceSystems from '@/components/marketplace/MarketplaceSystems.vue'
import IQOS from '@/components/IQOS.vue'

export default {
    components: {
        MarketplaceSystems,
        IQOS
    }
}
</script>

<style>

</style>